import { faHome, faRedo } from "@fortawesome/pro-solid-svg-icons";
import { ActionButton } from "components";
import React from "react";
import appLogo from '../../../public/icon_192.png';
import './error-page.scss';

export const ErrorPage = () => {
    
    return (   
        <div className={'error-boundary-container'}>
            <div className={'error-boundary-logo-container'}>
                <img src={appLogo} className={'error-boundary-logo'}/>
            </div>
            <div className={'error-boundary-version'}>{process.env.REACT_APP_VERSION}</div>
            <div className={'error-boundary-message-title'}>Something went wrong.</div>

            <div className={'error-boundary-buttons'}>
                <ActionButton 
                    icon={faRedo}
                    buttonText={'Reload'}
                    buttonColor={'#82BC24'}
                    onClick={() => location.reload()}
                />

                <ActionButton 
                    icon={faHome}
                    buttonText={'Home'}
                    buttonColor={'#48ACF0'}
                    onClick={() => window.location.href = '/load-assignments'}
                />
            </div>
        </div> 
    )
} 